import clsx from "clsx";

import { flexRender, type Header } from "@tanstack/react-table";

interface Props<T> {
  header: Header<T, unknown>;
  className?: string;
}

export const HeaderCell = <T,>({ header, className }: Props<T>) => {
  const isFirst = header.column.getIsFirstColumn();
  const isLast = header.column.getIsLastColumn();
  const isPinned = header.column.getIsPinned();
  const startPosition = header.column.getStart("left");

  return (
    <th
      className={clsx("p-0 group", className, {
        "is-first-column": isFirst,
        "is-last-column": isLast,
        "sticky z-3": isPinned,
      })}
      style={{
        width: header.column.getSize(),
        left: isPinned ? startPosition : undefined,
      }}
    >
      {flexRender(header.column.columnDef.header, header.getContext())}
    </th>
  );
};
